import { BaseReceiptStatusDto } from '@api';

const baseOrderStatusDto: BaseReceiptStatusDto = {
  id: 0,
  status: '',
  created: '2021-01-01Z00:00:000Z',
  lastChange: '2021-01-01Z00:00:000Z',
};

export const ORDER_STATUS: BaseReceiptStatusDto[] = [
  {
    ...baseOrderStatusDto,
    id: 1,
    status: 'Status A',
  },
  {
    ...baseOrderStatusDto,
    id: 2,
    status: 'Status B',
  },
  {
    ...baseOrderStatusDto,
    id: 3,
    status: 'Status C',
  },
  {
    ...baseOrderStatusDto,
    id: 4,
    status: 'Status D',
  },
];
